import { render } from "./TalkToMyDataStreaming.vue?vue&type=template&id=d34422ee&scoped=true"
import script from "./TalkToMyDataStreaming.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataStreaming.vue?vue&type=script&lang=js"

import "./TalkToMyDataStreaming.vue?vue&type=style&index=0&id=d34422ee&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34422ee"]])

export default __exports__